import PropTypes from 'prop-types';

import { Form } from 'antd';

const FormWrapper = ({ children }) => {
  <Form>{children}</Form>;
};

FormWrapper.propTypes = {
  children: PropTypes.node,
};

export default FormWrapper;
